import React from "react";
import { Card } from "react-bootstrap";
import Chart from "react-apexcharts";
import { GraphCardsHeader } from "@ui";

function PolarChart({ labels, series, title, height = 300, graphColor }) {
  let chartOptions = {
    series: series || [],
    options: {
      colors: graphColor
        ? graphColor
        : ["#13388C", "#159A6C", "#156078", "#1D81A2", "#cecdcd"],
      chart: {
        type: "polarArea",
      },
      stroke: {
        colors: ["#fff"],
      },
      fill: {
        opacity: 1,
      },
      legend: {
        position: "bottom",
        formatter: function (label, { w }) {
          const index = w?.config?.labels?.indexOf(label) || 0;
          const value = w?.config?.series[index] || 0;
          return `${label} (${value}%)`;
        },
      },
      labels: labels || [],
      yaxis: {
        show: false,
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
              height: 300,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
      tooltip: {
        y: {
          title: {
            formatter: (value) => {
              return value + ` ( % ) `;
            },
          },
        },
      },
    },
  };

  return (
    <Card className="d-flex flex-column flex-grow-1 h-100 m-0">
      <GraphCardsHeader title={title} titleCenter={true} />
      <Card.Body className="flex-grow-1">
        <div
          id="chart"
          className="d-flex align-items-center justify-content-center"
        >
          <Chart
            options={chartOptions.options}
            series={chartOptions.series}
            type="polarArea"
            height={height}
          />
        </div>
      </Card.Body>
    </Card>
  );
}

export default PolarChart;
